<div *ngIf="shouldDisplay()" class="sellerDescription">
  <p>
    {{ descriptionText | slice: 0:descriptionMaxChar }}{{ descriptionText.length > descriptionMaxChar ? '...' : '' }}
  </p>
  <p *ngIf="showTranslate && translatedDescription" i18n="@@PRODUCT.DESCRIPTION.TRANSLATED_BY_GOOGLE">
    Translated by Google
  </p>

  <div class="sellerDescription__action">
    <button
      *ngIf="descriptionText.length > maxChar"
      class="sellerDescription__action__btn sellerDescription__action__btn--readMore"
      (click)="toggleDescriptionMaxChar()"
    >
      <span *ngIf="descriptionText.length > descriptionMaxChar" i18n="@@PRODUCT.DESCRIPTION.READ_MORE">Read more</span>
      <span *ngIf="!(descriptionText.length > descriptionMaxChar)" i18n="@@PRODUCT.DESCRIPTION.READ_LESS"
        >Read less</span
      >
    </button>
    <button
      *ngIf="translatable"
      class="sellerDescription__action__btn sellerDescription__action__btn--translate"
      (click)="toggleTranslation()"
    >
      <span *ngIf="showTranslate && translatedDescription" i18n="@@PRODUCT.DESCRIPTION.TRANSLATE_CANCEL"
        >Untranslate</span
      >
      <span *ngIf="!(showTranslate && translatedDescription)" i18n="@@PRODUCT.DESCRIPTION.TRANSLATE">Translate</span>
    </button>
  </div>
</div>
